import RouterDom from './util/RouterDom';
import './App.css';

function App() {
  return (
      <RouterDom />
  );
}

export default App;
